<div class="col align-self-center mt-3" style="text-align:center;">
  <span>
    <ng-container *ngIf="!animalEntries || !animalEntries.entries">
      <h1 class="text-warning"> MISSING ANIMAL ENTRY DATA! </h1>
      <h5 class="text-warning">add the 'animalEntries' parameter to &lt;app-animal-rarities&gt;!</h5>
    </ng-container>

    <ng-container *ngIf="animalEntries && animalEntries.entries">
      <ng-container *ngFor="let entry of animalEntries.entries; let i = index;">

        <!-- Template for tooltipable entry -->
        <span class="d-inline-block u-lg-avatar u-xl-avatar--bordered-{{entry.rarity}} rounded-circle ml-n3">
          <img class="img-fluid rounded-circle" [appLazyload]="animalData.get(entry.animal)[1]"
               [alt]="animalData.get(entry.animal)[2]"
               [tooltip]="animalData.get(entry.animal)[0]"
               tooltipPosition="top"
               containerClass="ui-tooltip-{{entry.rarity}}">
        </span>

      </ng-container>
    </ng-container>
  </span>
</div>

<!-- Legend -->
<div class="row mt-2 responsiveDots">
    <div class="clearfix d-none d-xl-inline col-xl-1"></div>
    <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
        <span class="dot dot-1"></span><span style="font-size:85%">&ensp;=&ensp;Commonly Seen</span>
    </div>
    <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
        <span class="dot dot-2 offset-xl-1"></span><span
            style="font-size:85%">&ensp;=&ensp;Often Seen</span>
    </div>
    <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
        <span class="dot dot-3 offset-xl-1"></span><span
            style="font-size:85%">&ensp;=&ensp;Rarely Seen</span>
    </div>
</div>
<!-- End Legend -->
